<!-- HSK判断题 -->
<template>
  <div class="ques-area" v-if="currItem.answers">
    <question-description :currItem="currItem" :code="currItem.topic_type"></question-description>
    <div class="example" v-if="!isSPC">
      {{ currItem.is_example ? $t("hsk_example") : currItem.index }}
    </div>
    <div class="panel-content">
      <div class="panel-content-answers">
        <ul class="list-answers" ref="answers">
          <li
            v-for="(item, index) in answers"
            :class="[
              'item-answer',
              {
                success: !isExamMode && item.correct,
                error: !isExamMode && !item.correct && isError && currItem.answer == item.index,
                selected: (isExamMode && item.selected) || (currItem.is_example && item.correct),
              },
            ]"
            :key="`${currItem.index}_${index}`"
            :data-correct="item.correct ? 1 : 0"
            ref="answer"
            @click="handleCheck($event, item)"
          >
            <div class="item-key">{{ item.flag }}</div>
            <p>{{ item.content }}</p>
          </li>
        </ul>
      </div>
      <div class="panel-content-result result-correct" v-if="!isExamMode && !isError && !currItem.is_example">
        <p class="correct-tips">
          {{ $t("textbook_chioce_word_text_correct_tip") }}
        </p>
        <div class="correct-box" v-show="analysisText">
          <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
          <p class="correct-box-answer">
            {{ analysisText }}
          </p>
        </div>
      </div>

      <div class="panel-content-result result-error" v-if="!isExamMode && isError && !currItem.is_example">
        <p class="error-tips">
          {{ $t("textbook_chioce_word_text_error_tip") }}
        </p>
        <div class="result-show">
          <div class="your-answer">{{ $t("hsk_your_answer") }}{{ myAnswerText }}</div>
          <p class="correct-answer">{{ $t("hsk_correct_answer") }}{{ successAnswerText }}</p>
        </div>
        <div class="correct-box" v-show="analysisText">
          <p class="correct-box-title">{{ $t("hsk_answer_analysis") }}</p>
          <p class="correct-box-answer">
            {{ analysisText }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhoneticText from "@/components/ui/phoneticText";
import QuestionDescription from "@/components/hsk/questionDescription";

export default {
  components: { PhoneticText, QuestionDescription },
  data() {
    return {
      // 试题列表
      items: [],
      // 当前试题Index
      currIndex: 0,
      // 当前试题正确答案项
      currCorrectAnswer: {},

      // 是否禁止点击
      isDisabled: false,
      changeBtn: false,
    };
  },
  props: {
    //当前试题项
    currItem: {
      type: Object,
      required: true,
    },
    isExamMode: {
      type: Boolean,
      required: true,
    },
    isSPC: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    isError() {
      let flag = "";
      if (this.currItem.answer) {
        for (let i = 0; i < this.currItem.answers.length; i++) {
          if (this.currItem.answers[i].correct && this.currItem.answers[i].index == this.currItem.answer) {
            flag = this.currItem.answers[i].index;
            break;
          }
        }
      }
      return this.currItem.answer != flag || (this.currItem.answer == "" && this.currItem.answer != undefined);
    },
    successAnswerText() {
      let flag = "";
      for (let i = 0; i < this.currItem.answers.length; i++) {
        if (this.currItem.answers[i].correct) {
          flag = this.currItem.answers[i].flag;
          break;
        }
      }
      return flag;
    },
    myAnswerText() {
      let flag = "";
      if (this.currItem.answer) {
        for (let i = 0; i < this.currItem.answers.length; i++) {
          if (this.currItem.answers[i].index == this.currItem.answer) {
            flag = this.currItem.answers[i].flag;
            break;
          }
        }
      }
      return flag;
    },

    language() {
      let local = localStorage.getItem("language");
      if (local == "zh") {
        return "cn";
      } else {
        return local;
      }
    },
    analysisText() {
      return this.currItem.analysis[this.language]
        ? this.currItem.analysis[this.language]
        : this.currItem.analysis["cn"];
    },
    answers() {
      if (this.currItem.answer && !this.changeBtn) {
        this.currItem.answers = this.selectedAnswer(this.currItem.answer);
      }
      this.changeBtn = false;
      return this.currItem.answers;
    },
  },
  watch: {},
  methods: {
    //点击选项
    handleCheck(event, item) {
      if (!this.isExamMode) {
        return;
      }
      if (this.currItem.is_example) {
        return;
      }
      this.resetAnswerSelected();
      this.currItem.answers = this.selectedAnswer(item.index);
      const isCorrect = parseInt(event.currentTarget.dataset.correct);
      this.changeBtn = true;
      // 作答的对象
      let ansObj = {
        questionId: this.currItem.index,
        answer: item.index.toString(),
        judge: isCorrect,
        scores: isCorrect == 1 ? this.currItem.score : 0,
        segmentCode: this.currItem.segment_code,
        partCode: this.currItem.part_code,
        ifGroup: this.currItem.ifGroup,
        // num: this.currItem.num,
        // nnum: this.currItem.nnum,
      };
      // 选中后延时1ms再提交
      setTimeout(() => {
        this.$emit("saveRes", ansObj);
      }, 200);
    },

    //重置选项为未点击
    resetAnswerSelected() {
      return this.currItem.answers.map((item) => {
        item.selected = false;
        return item;
      });
    },
    //点击选项置为true
    selectedAnswer(chooseIndex) {
      return this.currItem.answers.map((item) => {
        if (chooseIndex == item.index) {
          item.selected = true;
        }
        return item;
      });
    },
  },
  created() {
    if (this.currItem && this.currItem.answers) {
      this.currItem.answers = this.resetAnswerSelected(this.currItem.answers);
    }
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.ques-area {
  width: 100%;
  position: relative;
  padding-top: 45px;
  .text-ques {
    position: absolute;
    left: 29px;
    top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #1c84fe;
    margin-top: 0px;
  }
  .example {
    background: rgba(63, 70, 81, 1);
    border-radius: 4px;
    color: #fff;
    padding: 5px;
    font-size: 12px;
    position: absolute;
    top: 40px;
    left: 28px;
  }
  .panel-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px 29px 0px 29px;
    img {
      width: 280px;
      height: 158px;
      border-radius: 5px;
      object-fit: contain;
    }
    &-answers {
      width: 100%;
      margin-top: 40px;
      margin-bottom: 40px;
      .list-answers {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }

      .item-answer {
        cursor: pointer;
        position: relative;

        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 470px;
        min-height: 39px;
        padding: 10px 10px 10px 40px;
        font-size: 15px;
        margin-top: 10px;

        color: rgba(63, 70, 81, 1);
        background: rgba(242, 243, 247, 1);
        border-radius: 6px;
        box-sizing: border-box;

        .text {
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .item-key {
          position: absolute;
          font-size: 15px;
          font-weight: 600;
          color: rgba(174, 186, 198, 1);
          top: 9px;
          left: 16px;
        }
        &:after {
          position: absolute;
          content: "";
          width: 16px;
          height: 16px;
          right: -24px;
          top: 50%;
          transform: translateY(-50%);
          background-position: 0 0;
          background-repeat: no-repeat;
          background-size: cover;
        }
        &.selected {
          border: 2px solid #faae56;
          background: #ffffff;
          // ::v-deep.phtContent > .normal_pht > .pht_single > .pinyin > span {
          //   color: #1c84fe !important;
          //   span {
          //     color: #1c84fe !important;
          //   }
          // }
          // ::v-deep.phtContent > .normal_pht > .pht_single > .hz > span {
          //   color: #1c84fe !important;
          //   span {
          //     color: #1c84fe !important;
          //   }
          // }
        }
        &.success {
          background: #ffffff; // 设置白色背景
          border: 1px solid rgba(9, 203, 160, 1);
          color: #09cba0;

          // &:after {
          //   background-image: url(~@/assets/images/icon-test-ok.png);
          // }
          ::v-deep.phtContent > .normal_pht > .pht_single > .pinyin > span {
            color: #09cba0 !important;
          }
          ::v-deep.phtContent > .normal_pht > .pht_single > .hz > span {
            color: #09cba0 !important;
          }
        }

        &.error {
          border: 1px solid #fc5a5a;
          color: #fc5a5a;
          background: #ffffff;
          ::v-deep.phtContent > .normal_pht > .pht_single > .pinyin > span {
            color: #fc5a5a !important;
          }
          ::v-deep.phtContent > .normal_pht > .pht_single > .hz > span {
            color: #fc5a5a !important;
          }
          // &:after {
          //   background-image: url(~@/assets/images/icon-test-no.png);
          // }
        }
      }
    }
    &-result {
      padding: 40px 30px 20px 0;
      border-top: 1px dashed #e6eaef;
      width: 100%;
      &.result-error,
      &.result-correct {
        p.error-tips {
          font-size: 14px;
          color: #fc5a5a;
          margin-bottom: 20px;
        }
        p.correct-tips {
          font-size: 14px;
          color: rgba(9, 203, 160, 1);
          margin-bottom: 20px;
        }
        .result-show {
          display: flex;
          align-items: center;
          margin-bottom: 20px;
        }
        .your-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          img {
            width: 12px;
            height: 12px;
            margin-left: 20px;
          }
        }
        p.correct-answer {
          font-size: 14px;
          font-weight: 500;
          color: rgba(84, 89, 97, 1);
          line-height: 14px;
          margin-left: 45px;
        }
        .correct-box {
          background: #fafafb;
          border-radius: 10px;
          padding: 20px;

          &-title {
            font-size: 14px;
            font-weight: bold;
            color: rgba(63, 70, 81, 1);
            margin-bottom: 10px;
          }
          &-answer {
            font-size: 14px;
            font-weight: 400;
            color: rgba(84, 89, 97, 1);
            line-height: 21px;
            white-space: pre-line;
          }
        }
      }
    }
  }
}
</style>
